import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// Define a type for the slice state
interface UserState {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  club_membership_id: string;
  date_of_birth: string;
  gender: string;
  address: string;
  city: string;
  state_id: number;
  zip: string;
  photo: string;
  photo_key: string;
  member_payment_methods: any[];
}

const initialState: UserState = {
  id: 0,
  first_name: '',
  last_name: '',
  email: '',
  phone: '',
  club_membership_id: '',
  date_of_birth: '',
  gender: '',
  address: '',
  city: '',
  state_id: 0,
  zip: '',
  photo: '',
  photo_key: '',
  member_payment_methods: [],
};

export const userDetails = createSlice({
  name: 'userDetails',
  initialState,
  reducers: {
    userData: (state, val: PayloadAction<UserState | null>) => {
      return { ...state, ...val.payload };
    },
  },
});

// Action creators are generated for each case reducer function
export const { userData } = userDetails.actions;
export default userDetails.reducer;
